import { WellframeApi } from 'store/api';

export interface SupportRequest {
  type: 'signup_help';
  email: string;
  name?: string;
  phone_number?: string;
  date_of_birth?: string;
  member_id?: string;
  access_code?: string;
  hospital_id?: string;
  invited_by?: string;
  state_of_residence?: string;
  source_screen?: string;
  app_name?: string;
  app_version?: string;
  language?: string;
  device_type?: string;
  browser_type?: string;
  browser_version?: string;
}

export interface SupportRequestResponse {
  ticket: {
    id: number;
    subject: string;
    status: string;
    custom_fields: Record<string, string>;
  };
}

// Authenticated; the requester email comes from the auth token, not the body.
export interface DeleteAccountRequest {
  name?: string;
  app_name?: string;
  app_version?: string;
  device_type?: string;
  browser_type?: string;
  browser_version?: string;
}

export const supportService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    createSupportRequest: builder.mutation<SupportRequestResponse, SupportRequest>({
      query: (body) => ({
        url: '/mobileapi/v1/support/requests',
        method: 'POST',
        body,
      }),
    }),
    createDeleteAccountRequest: builder.mutation<
      SupportRequestResponse,
      { memberUuid: string; body: DeleteAccountRequest }
    >({
      query: ({ memberUuid, body }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/account-deletion-requests`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateSupportRequestMutation, useCreateDeleteAccountRequestMutation } =
  supportService;
